import React from 'react';
import { Trans } from 'react-i18next';
import './CookiesPolicy.scss';
import getPrivacyPolicyLink from '../../utils/getPrivacyPolicyLink';

const CookiesPolicy = () => (
  <section className="berg-page-cookies-policy">
    <Trans
      ns="pages"
      i18nKey="cookies"
      components={{
        h1: <h1 />,
        p: <p />,
        br: <br />,
        h2: <h2 />,
        a: (
          <a
            href={getPrivacyPolicyLink()}
            target="_blank"
            rel="noopener noreferrer"
          />
        ),
      }}
    ></Trans>
  </section>
);

export default CookiesPolicy;
